import React, { useState } from 'react';

import cn from 'classnames';
import { get } from 'lodash';
import Dropzone from 'react-dropzone';
import { MdInsertDriveFile } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from 'scouting-ui/lib';

import { useUploadMBFileMutation } from '@modules/councilUnits/api';
import { S } from '@shared/components';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';
import { toastService } from '@toasts';

import styles from './MBRUploadForm.less';

function AddMBFile() {
  const orgGUID = useSelector(organizationGuidSel);
  const [files, setFiles] = useState<File | undefined>(undefined);

  const [uploadMBFile] = useUploadMBFileMutation();

  const addFile = async (file?: File) => {
    if (!file) return;
    try {
      const formData = new FormData();

      formData.append('file', file);

      await uploadMBFile({
        payload: formData,
        orgGUID: orgGUID,
      }).unwrap();

      toastService.success(
        <FormattedMessage id="councilUnits.CouncilUnitsPage.UploadMBR.uploadMessage" />,
      );
    } catch (error) {
      const errorMessage = get(error, ['data', 'errorDesc']);
      if (errorMessage) {
        toastService.error(errorMessage);
      }
    }
  };

  const onDrop = ([acceptedFile]: Array<File>) => {
    if (!acceptedFile) {
      toastService.error(
        <React.Fragment>
          <FormattedMessage id="councilUnits.CouncilUnitsPage.UploadMBRDropzone.invalidAction" />
        </React.Fragment>,
      );
      return;
    }

    setFiles(acceptedFile);
    addFile(acceptedFile);
  };

  const showAside = files?.size;
  return (
    <div className={cn(styles.container, { [styles.showAside]: showAside })}>
      <S size="3" className={styles.descriptionMessage}>
        <FormattedMessage id="councilUnits.CouncilUnitsPage.UploadMBR.Description" />
      </S>
      <Dropzone
        accept=".csv"
        className={cn(styles.container, 'className')}
        activeClassName={styles.active}
        disabledClassName={styles.disabled}
        multiple={false}
        onDrop={onDrop}
      >
        <div className={styles.content}>
          <MdInsertDriveFile className={styles.icon} />
          <div className={styles.instructions}>
            <S size="2">
              <FormattedMessage id="councilUnits.CouncilUnitsPage.UploadMBRDropZone.importLimit" />
            </S>
            <S size="2">
              <FormattedMessage id="councilUnits.CouncilUnitsPage.UploadMBRDropZone.dragHere" />
            </S>
            <S size="2">
              <FormattedMessage id="councilUnits.CouncilUnitsPage.UploadMBRDropZone.or" />
            </S>
          </div>
          <Button type="default">Browse</Button>
        </div>
      </Dropzone>
    </div>
  );
}

export default AddMBFile;
